import { stratacor } from './stratacor';
import { visionfirm } from './visionfirm';
import { deltaDental } from './delta-dental';
import type { BrandConfig } from './types';

const brands: Record<string, BrandConfig> = {
  stratacor,
  visionfirm,
  'delta-dental': deltaDental,
};

export function getBrandConfig(key?: string): BrandConfig {
  const brandKey = key ?? 'stratacor';
  const config = brands[brandKey];
  if (!config) {
    throw new Error(
      `Unknown brand: "${brandKey}". Available brands: ${Object.keys(brands).join(', ')}`
    );
  }
  return config;
}

export type { BrandConfig };
